import { Link, useMatch } from 'react-router-dom';

const TAB =
  'rounded-full px-4 py-1.5 text-sm font-trirong_reg transition-colors focus:outline-none focus:ring-2 focus:ring-lime-600/40';
const ACTIVE = 'bg-cream text-lime-700';
const IDLE = 'text-gray-600 hover:text-lime-700';

export default function AdminNav() {
  // Every non-stats admin route (the list, /admin/new, /admin/:id) is the Posts
  // section.
  const onStats = !!useMatch('/admin/stats');

  return (
    <nav className="mb-8 flex items-center gap-2" aria-label="Admin sections">
      <Link
        to="/admin"
        aria-current={onStats ? undefined : 'page'}
        className={`${TAB} ${onStats ? IDLE : ACTIVE}`}
      >
        Posts
      </Link>
      <Link
        to="/admin/stats"
        aria-current={onStats ? 'page' : undefined}
        className={`${TAB} ${onStats ? ACTIVE : IDLE}`}
      >
        Stats
      </Link>
    </nav>
  );
}
